.bk{justify-content:flex-end;}